import { ChatText } from "@phosphor-icons/react";
import MarketplaceBadge from "@/components/orders/MarketplaceBadge";

export default function ObservationsCard({ order }) {
  if (!order.store_name && !order.observations && !order.internal_observations) return null;
  return (
    <div className="border border-black bg-white" data-testid="bling-observations">
      <div className="border-b border-black p-4 flex items-center gap-2"><ChatText size={16} weight="bold" /><div className="overline text-zinc-500">OBSERVAÇÕES DO BLING</div></div>
      <div className="p-5 space-y-3 text-sm">
        {order.store_name && (
          <div className="flex items-center gap-3 flex-wrap" data-testid="order-store-name">
            <div className="overline text-zinc-400">LOJA</div>
            <div className="flex items-center gap-2">
              {order.marketplace_source && <MarketplaceBadge marketplace={order.marketplace_source} />}
              <span className="font-mono font-semibold">{order.store_name}</span>
            </div>
          </div>
        )}
        {order.observations && <div><div className="overline text-zinc-400 mb-1">PÚBLICAS</div><div>{order.observations}</div></div>}
        {order.internal_observations && <div><div className="overline text-zinc-400 mb-1">INTERNAS</div><div className="text-zinc-700">{order.internal_observations}</div></div>}
      </div>
    </div>
  );
}
